export default __webpack_public_path__ + "static/media/Lamayuru2.5ccd1fc6.jpg";